<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="520">
        <v-card>
            <v-card-title class="text-h6">
                Vérification de votre position
            </v-card-title>
            <v-card-text>
                <div v-if="verifyResult && verifyResult.id">
                    <div v-if="verifyResult.mail_send == '1'">
                        Vous avez atteint le haut de la liste d'attente. Un email vous a déjà été envoyé pour
                        racheter un dossard dans un délai de 24 heures. Vous ne recevrez pas d'autres emails pour
                        cette course de notre part.
                    </div>
                    <div v-else>
                        Vous êtes bien inscrit sur la liste d'attente pour ce parcours.
                        <br />
                        <div v-if="verifyResult.mail != mail">
                            Vous êtes inscrit sur la liste d'attente dans <b>l'équipe de {{ verifyResult.mail
                                }}</b>, la notification en cas de mise en vente sera envoyée à cette adresse.
                        </div>
                        Position actuelle: <strong>{{ verifyResult.position }}</strong>
                    </div>
                </div>
                <div v-else>
                    Vous n'êtes pas encore inscrit sur la liste d'attente pour ce parcours.
                    <br />
                    <span v-if="!hasListeAttenteBoursePrivee">Vous pouvez vous inscrire dès maintenant.</span>
                </div>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn variant="text" @click="$emit('update:modelValue', false)">Fermer</v-btn>
                <SportipsButton
                    v-if="(!verifyResult || !verifyResult.id) && !hasListeAttenteBoursePrivee"
                    action-button
                    @click="$emit('register-now')"
                >
                    S'inscrire maintenant
                </SportipsButton>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'VerifyPositionDialog',
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        verifyResult: {
            type: Object,
            default: null,
        },
        mail: {
            type: String,
            default: '',
        },
        hasListeAttenteBoursePrivee: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue', 'register-now'],
}
</script>
